import gql from 'graphql-tag';

export const LISTING_INTERACTIVE_MAP_FRAGMENT = gql`
    fragment LISTING_INTERACTIVE_MAP_FRAGMENT on ListingData {
        location {
            coordinates {
                latitude
                longitude
            }
        }
    }
`;
